/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiResponseDTOAuthenticationDTO } from '../models/ApiResponseDTOAuthenticationDTO';
import type { ApiResponseDTODeviceBiometricDTO } from '../models/ApiResponseDTODeviceBiometricDTO';
import type { ApiResponseDTORefreshTokenResponseDTO } from '../models/ApiResponseDTORefreshTokenResponseDTO';
import type { ApiResponseDTOSignInResponseDTO } from '../models/ApiResponseDTOSignInResponseDTO';
import type { ApiResponseDTOVoid } from '../models/ApiResponseDTOVoid';
import type { LogoutRequestDTO } from '../models/LogoutRequestDTO';
import type { MobileSignInRequest } from '../models/MobileSignInRequest';
import type { RefreshTokenRequestDTO } from '../models/RefreshTokenRequestDTO';
import type { SignInRequest } from '../models/SignInRequest';
import type { SignInRequestBiometricDTO } from '../models/SignInRequestBiometricDTO';
import type { SignInRequestForPOSDevice } from '../models/SignInRequestForPOSDevice';
import type { UpdateDeviceBiometricDTO } from '../models/UpdateDeviceBiometricDTO';
import type { WebSignInRequest } from '../models/WebSignInRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AuthenticationApiService {

    /**
     * Logout user
     * Logs out the merchant by inactivating their current token
     * @returns ApiResponseDTOVoid OK
     * @throws ApiError
     */
    public static logout(): CancelablePromise<ApiResponseDTOVoid> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/authentication/logout',
            errors: {
                422: `Unprocessable Entity`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * Logout POS user
     * Logs out the merchant from their POS Device by inactivating their current token and updating their session details
     * @param requestBody
     * @returns ApiResponseDTOVoid OK
     * @throws ApiError
     */
    public static posLogout(
        requestBody: LogoutRequestDTO,
    ): CancelablePromise<ApiResponseDTOVoid> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/authentication/pos/logout',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Unprocessable Entity`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * Biometric Profile Update
     * This endpoint updates the user's device with the public key to sign challenges
     * @param requestBody
     * @returns ApiResponseDTOVoid OK
     * @throws ApiError
     */
    public static updateDeviceBiometricProfile(
        requestBody: UpdateDeviceBiometricDTO,
    ): CancelablePromise<ApiResponseDTOVoid> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/authentication/profile',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Unprocessable Entity`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * Refresh token
     * Generates new token given the refresh token
     * @param requestBody
     * @param channel
     * @returns ApiResponseDTORefreshTokenResponseDTO OK
     * @throws ApiError
     */
    public static refreshToken(
        requestBody: RefreshTokenRequestDTO,
        channel?: 'WEB' | 'MOBILE' | 'POS',
    ): CancelablePromise<ApiResponseDTORefreshTokenResponseDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/authentication/refresh-token',
            headers: {
                'Channel': channel,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Unprocessable Entity`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * Sign In
     * Sign-in to Zenz to perform authorized actions
     * @param channel
     * @param xApiKey
     * @param requestBody
     * @param deviceId
     * @returns ApiResponseDTOSignInResponseDTO OK
     * @throws ApiError
     */
    public static signIn(
        channel: 'WEB' | 'MOBILE' | 'POS',
        xApiKey: string,
        requestBody: SignInRequest,
        deviceId?: string,
    ): CancelablePromise<ApiResponseDTOSignInResponseDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/authentication/signin',
            headers: {
                'Channel': channel,
                'Device-ID': deviceId,
                'X-Api-Key': xApiKey,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Unprocessable Entity`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * Biometric Challenge
     * Retrieve the challenge key for the biometric login process
     * @param userId
     * @param deviceId
     * @returns ApiResponseDTODeviceBiometricDTO OK
     * @throws ApiError
     */
    public static generateBiometricChallenge(
        userId: string,
        deviceId: string,
    ): CancelablePromise<ApiResponseDTODeviceBiometricDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/authentication/signin/biometric-challenge',
            query: {
                'userId': userId,
                'deviceId': deviceId,
            },
            errors: {
                422: `Unprocessable Entity`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * Biometric sign in for mobile device
     * Sign-in to Zenz Merchant App using the biometric option for mobile devices.
     * @param channel
     * @param deviceId
     * @param requestBody
     * @returns ApiResponseDTOSignInResponseDTO OK
     * @throws ApiError
     */
    public static signInWithBiometric(
        channel: 'WEB' | 'MOBILE' | 'POS',
        deviceId: string,
        requestBody: SignInRequestBiometricDTO,
    ): CancelablePromise<ApiResponseDTOSignInResponseDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/authentication/signin/biometric-login',
            headers: {
                'Channel': channel,
                'Device-ID': deviceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Unprocessable Entity`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * Sign In with Mobile Device
     * Sign-in to Zenz Merchant App using mobile device with OTP verification and device binding
     * @param requestBody
     * @param deviceId
     * @param xApiKey
     * @returns ApiResponseDTOSignInResponseDTO OK
     * @throws ApiError
     */
    public static signInMobile(
        requestBody: MobileSignInRequest,
        deviceId?: string,
        xApiKey?: string,
    ): CancelablePromise<ApiResponseDTOSignInResponseDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/authentication/signin/mobile',
            headers: {
                'Device-ID': deviceId,
                'X-Api-Key': xApiKey,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                422: `Unprocessable Entity`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * Sign In For POS Devices
     * Sign-in to Zenz-POS to perform authorized actions
     * @param deviceId
     * @param requestBody
     * @param channel
     * @param xApiKey
     * @returns ApiResponseDTOSignInResponseDTO OK
     * @throws ApiError
     */
    public static signInForPosDevices(
        deviceId: string,
        requestBody: SignInRequestForPOSDevice,
        channel?: 'WEB' | 'MOBILE' | 'POS',
        xApiKey?: string,
    ): CancelablePromise<ApiResponseDTOSignInResponseDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/authentication/signin/pos',
            headers: {
                'Channel': channel,
                'Device-ID': deviceId,
                'X-Api-Key': xApiKey,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Unprocessable Entity`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * Sign In with Web Browser
     * Sign-in to Zenz using web browser (credentials only, no device binding)
     * @param requestBody
     * @param deviceId
     * @param xApiKey
     * @returns ApiResponseDTOSignInResponseDTO OK
     * @throws ApiError
     */
    public static signInWeb(
        requestBody: WebSignInRequest,
        deviceId?: string,
        xApiKey?: string,
    ): CancelablePromise<ApiResponseDTOSignInResponseDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/authentication/signin/web',
            headers: {
                'Device-ID': deviceId,
                'X-Api-Key': xApiKey,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                422: `Unprocessable Entity`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * Logout user V2 API
     * Logs out the merchant by inactivating their refresh and current access token
     * @param requestBody
     * @param channel
     * @returns ApiResponseDTOVoid OK
     * @throws ApiError
     */
    public static logoutV2(
        requestBody: LogoutRequestDTO,
        channel?: 'WEB' | 'MOBILE' | 'POS',
    ): CancelablePromise<ApiResponseDTOVoid> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/authentication/v2/logout',
            headers: {
                'Channel': channel,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Unprocessable Entity`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * Check 2FA
     * Check whether 2FA is active or inactive.
     * @returns ApiResponseDTOAuthenticationDTO OK
     * @throws ApiError
     */
    public static getVerification2Fa(): CancelablePromise<ApiResponseDTOAuthenticationDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/authentication/verification-2fa',
            errors: {
                422: `Unprocessable Entity`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * Check 2FA
     * Check whether 2FA is active or inactive.
     * @param userId
     * @returns ApiResponseDTOAuthenticationDTO OK
     * @throws ApiError
     */
    public static getVerification2Fa1(
        userId: string,
    ): CancelablePromise<ApiResponseDTOAuthenticationDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/authentication/verification-2fa/{userId}',
            path: {
                'userId': userId,
            },
            errors: {
                422: `Unprocessable Entity`,
                501: `Not Implemented`,
            },
        });
    }

}
